import { Directive, input } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

export const InputWrapperFormControlDirectiveInputs = [
  'isLabel',
  'submitted',
  'randomInputId',
  'valueLength',
  'isRequired',
  'control',
];

@Directive({
  selector: '[uiInputWrapperFormControl]',
  standalone: true,
})
export class InputWrapperFormControlDirective {
  readonly isLabel = input(true);

  readonly submitted = input(false);

  readonly randomInputId = input<string>();

  readonly valueLength = input(0);

  readonly isRequired = input<boolean>(false);

  readonly control = input<AbstractControl>(new FormControl()); // Přidání control

  readonly whenTouchedShowValidationErrors = input(true);
}
